import React, { useState } from "react";
import toggleInputType from "../../../assets/toggleInputType.png";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
// interface ITextField {
//   placeholder: string
// }

const PasswordField = (props: any) => {
  const [isPasswordType, setIsPasswordType] = useState(true);
  const { placeholder, value, register, errors, label } = props;
  return (
    <>
      <div className={tw`w-full my-2 text-left relative mt-4`}>
        <label htmlFor="" className="pb-2">
          {label}
        </label>
        <input
          placeholder={placeholder}
          defaultValue={value}
          {...register}
          type={isPasswordType ? "password" : "text"}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        />
        <img
          src={toggleInputType}
          onClick={() => setIsPasswordType(!isPasswordType)}
          alt="toogle input type"
          className={tw`absolute bottom-[10px] right-[10px]`}
        />
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default PasswordField;
